import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { Reveal, SectionLabel } from "../components/Motion";
import { useApp } from "../AppContext";
import { C, TRUST, IMAGES } from "../content";
import { Utensils, CalendarClock, Mic2, Stethoscope, Award, Sparkles, HeartHandshake, ArrowUpRight } from "lucide-react";

const ICONS = [Utensils, CalendarClock, Mic2, Stethoscope, Award, Sparkles, HeartHandshake];

export default function Trust() {
  const { t, lang } = useApp();
  return (
    <div>
      <Seo title="The Math, Bhakt Niwas & Seva" description="History of the Audumbar Narayan Swami Math and Bhakt Niwas, and the seva of the Sadguru Swami NarayanaNandaTirth Seva Trust — annadan, festivals, sanskars and social welfare." />
      <PageBanner label={lang === "mr" ? "मठ व सेवा" : "Math & Seva"} titleObj={C.math} image={IMAGES.ashramGate} />

      <section className="py-16 lg:py-24 max-w-[1100px] mx-auto px-4 lg:px-8">
        <Reveal>
          <SectionLabel>{lang === "mr" ? "मठ व भक्त निवास" : "The Math & Bhakt Niwas"}</SectionLabel>
          <p className="font-serif-head text-2xl lg:text-4xl text-earth-900 leading-snug">{t(C.math, "history")}</p>
        </Reveal>

        <div className="mt-16">
          <Reveal><SectionLabel>{lang === "mr" ? "सेवा व कार्यक्रम" : "Seva & Programmes"}</SectionLabel></Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
            {C.math.seva.map((s, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={i} delay={i * 0.06}>
                  <div className="h-full rounded-2xl border border-earth-900/10 bg-white p-7" data-testid={`seva-${i}`}>
                    <div className="w-12 h-12 rounded-xl bg-deepred-700/10 text-deepred-700 flex items-center justify-center mb-5"><Icon size={24} /></div>
                    <h4 className="font-serif-head text-2xl text-earth-900">{t(s, "t")}</h4>
                    <p className="mt-2 text-earth-800/75">{t(s, "d")}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal delay={0.1} className="mt-16">
          <div className="rounded-3xl bg-sand-100 border border-earth-900/10 p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <h3 className="font-serif-head text-2xl text-earth-900">{lang === "mr" ? "आश्रमातील दैनंदिन दिनचर्या" : "Daily Programme at the Ashram"}</h3>
              <p className="text-earth-700 mt-1">{lang === "mr" ? "नित्य पूजा, समाधी पूजा, अन्नदान व आरती." : "Daily puja, samadhi puja, annadan and aarti."}</p>
            </div>
            <Link to="/darshan" data-testid="math-dincharya-cta" className="inline-flex items-center gap-2 rounded-full bg-saffron-500 hover:bg-saffron-600 text-white px-6 py-3 font-semibold transition-all hover:-translate-y-1 whitespace-nowrap">
              {lang === "mr" ? "दिनचर्या पहा" : "View Dincharya"} <ArrowUpRight size={18} />
            </Link>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="mt-8">
          <div className="rounded-xl border border-earth-900/15 bg-sand-50 px-6 py-4 text-earth-700">
            <span className="font-semibold">{lang === "mr" ? "ट्रस्ट:" : "Trust:"}</span> {lang === "mr" ? TRUST.name_mr : TRUST.name_en} · PAN {TRUST.pan} · Reg./TAKNIKI {TRUST.reg} · {lang === "mr" ? "देणगी ८०जी करसवलत" : "80G tax-exempt donations"}
          </div>
        </Reveal>
      </section>
    </div>
  );
}
